/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="9.99988"
				cy="12"
				r="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.94346 19.0001L15.5999 19.0001C17.8401 19.0001 18.9602 19.0001 19.8158 18.5641C20.5685 18.1807 21.1804 17.5687 21.5639 16.8161C21.9999 15.9604 21.9999 14.8403 21.9999 12.6001L21.9999 11.4001C21.9999 9.15991 21.9999 8.03981 21.5639 7.18416C21.1804 6.43151 20.5685 5.81959 19.8158 5.4361C18.9602 5.00012 17.8401 5.00012 15.5999 5.00012L9.94346 5.00012C8.86076 5.00012 8.31941 5.00012 7.81651 5.13318C7.37088 5.25108 6.94898 5.44513 6.56944 5.70675C6.14114 6.00199 5.78883 6.41301 5.08422 7.23506L4.56993 7.83506L4.56993 7.83506C3.30282 9.31335 2.66927 10.0525 2.4278 10.8814C2.21498 11.612 2.21498 12.3882 2.4278 13.1188C2.66927 13.9477 3.30283 14.6869 4.56993 16.1652L5.08422 16.7652C5.78883 17.5872 6.14114 17.9983 6.56944 18.2935C6.94898 18.5551 7.37088 18.7492 7.81651 18.8671C8.31941 19.0001 8.86076 19.0001 9.94346 19.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M21.9999 12.6C21.9999 14.8402 21.9999 15.9603 21.5639 16.816C21.1804 17.5686 20.5685 18.1805 19.8158 18.564C18.9602 19 17.8401 19 15.5999 19L9.94346 19C8.86076 19 8.31941 19 7.81651 18.8669C7.37088 18.749 6.94898 18.555 6.56944 18.2934C6.14114 17.9981 5.78883 17.5871 5.08422 16.7651L4.56993 16.1651C3.30282 14.6868 2.66927 13.9476 2.4278 13.1187C2.21498 12.3881 2.21498 11.6119 2.4278 10.8813C2.66927 10.0524 3.30282 9.31323 4.56993 7.83494L5.08422 7.23494C5.78883 6.41289 6.14114 6.00187 6.56944 5.70663C6.94898 5.44501 7.37088 5.25096 7.81651 5.13306C8.31941 5 8.86076 5 9.94346 5H15.5999C17.8401 5 18.9602 5 19.8158 5.43597C20.5685 5.81947 21.1804 6.43139 21.5639 7.18404C21.9999 8.03968 21.9999 9.15979 21.9999 11.4L21.9999 12.6ZM9.99988 14C11.1044 14 11.9999 13.1046 11.9999 12C11.9999 10.8954 11.1044 10 9.99988 10C8.89531 10 7.99988 10.8954 7.99988 12C7.99988 13.1046 8.89531 14 9.99988 14Z"
				fill="currentColor"
			/>
			<path
				d="M11.9999 12.0001C11.9999 13.1047 11.1044 14.0001 9.99988 14.0001C8.89531 14.0001 7.99988 13.1047 7.99988 12.0001C7.99988 10.8956 8.89531 10.0001 9.99988 10.0001C11.1044 10.0001 11.9999 10.8956 11.9999 12.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.59865 19.7502C8.51595 19.7502 7.9746 19.7502 7.4717 19.6172C7.02606 19.4993 6.60417 19.3052 6.22463 19.0436C5.79632 18.7484 5.44402 18.3374 4.73941 17.5153L3.58226 16.1653C2.31515 14.687 1.6816 13.9479 1.44013 13.1189C1.22731 12.3883 1.22731 11.6122 1.44013 10.8816C1.6816 10.0526 2.31515 9.31347 3.58226 7.83518L4.7394 6.48518C5.44402 5.66313 5.79632 5.25211 6.22463 4.95687C6.60416 4.69525 7.02606 4.50121 7.4717 4.3833C7.9746 4.25024 8.51595 4.25024 9.59865 4.25024H16.35C18.5902 4.25024 19.7103 4.25024 20.566 4.68622C21.3186 5.06971 21.9305 5.68163 22.314 6.43428C22.75 7.28993 22.75 8.41003 22.75 10.6502V13.3502C22.75 15.5905 22.75 16.7106 22.314 17.5662C21.9305 18.3189 21.3186 18.9308 20.566 19.3143C19.7103 19.7502 18.5902 19.7502 16.35 19.7502L9.59865 19.7502ZM9.9999 14C11.1045 14 11.9999 13.1046 11.9999 12C11.9999 10.8955 11.1045 10 9.9999 10C8.89533 10 7.9999 10.8955 7.9999 12C7.9999 13.1046 8.89533 14 9.9999 14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 5.00012L11.5 5.00012L9.94346 5.00012C8.86076 5.00012 8.31941 5.00012 7.81651 5.13318C7.37088 5.25108 6.94898 5.44513 6.56944 5.70675C6.14114 6.00199 5.78883 6.41301 5.08422 7.23506L4.56993 7.83506C3.30282 9.31335 2.66927 10.0525 2.4278 10.8814C2.21498 11.612 2.21498 12.3882 2.4278 13.1188C2.66927 13.9477 3.30282 14.6869 4.56993 16.1652L5.08422 16.7652C5.78883 17.5872 6.14114 17.9983 6.56944 18.2935C6.94898 18.5551 7.37088 18.7492 7.81651 18.8671C8.31941 19.0001 8.86076 19.0001 9.94346 19.0001L15.5999 19.0001C17.8401 19.0001 18.9602 19.0001 19.8158 18.5641C20.5685 18.1807 21.1804 17.5687 21.5639 16.8161C21.9999 15.9604 21.9999 14.8403 21.9999 12.6001L21.9999 10.5C21.9999 9.10455 21.9999 8.40682 21.8277 7.83907C21.4399 6.56059 20.4394 5.56012 19.1609 5.17233C18.5932 5.00012 17.8954 5.00012 16.5 5.00012V5.00012L16 5.00012M11.9999 12.0001C11.9999 13.1047 11.1044 14.0001 9.99988 14.0001C8.89531 14.0001 7.99988 13.1047 7.99988 12.0001C7.99988 10.8956 8.89531 10.0001 9.99988 10.0001C11.1044 10.0001 11.9999 10.8956 11.9999 12.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11.9999 12.0001C11.9999 13.1047 11.1044 14.0001 9.99988 14.0001C8.89531 14.0001 7.99988 13.1047 7.99988 12.0001C7.99988 10.8956 8.89531 10.0001 9.99988 10.0001C11.1044 10.0001 11.9999 10.8956 11.9999 12.0001Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.59865 19.75C8.51595 19.75 7.9746 19.75 7.4717 19.6169C7.02606 19.499 6.60417 19.305 6.22463 19.0434C5.79632 18.7481 5.44402 18.3371 4.73941 17.5151L3.58226 16.1651C2.31515 14.6868 1.6816 13.9476 1.44013 13.1187C1.22731 12.3881 1.22731 11.6119 1.44013 10.8813C1.6816 10.0524 2.31515 9.31323 3.58226 7.83494L4.7394 6.48494C5.44402 5.66289 5.79632 5.25187 6.22463 4.95663C6.60416 4.69501 7.02606 4.50096 7.4717 4.38306C7.9746 4.25 8.51595 4.25 9.59865 4.25H16.35C18.5902 4.25 19.7103 4.25 20.566 4.68597C21.3186 5.06947 21.9305 5.68139 22.314 6.43404C22.75 7.28969 22.75 8.40979 22.75 10.65V13.35C22.75 15.5902 22.75 16.7103 22.314 17.566C21.9305 18.3186 21.3186 18.9305 20.566 19.314C19.7103 19.75 18.5902 19.75 16.35 19.75L9.59865 19.75Z"
				fill="currentColor"
			/>
			<path
				d="M10 14C11.1046 14 12 13.1046 12 12C12 10.8954 11.1046 10 10 10C8.89543 10 8 10.8954 8 12C8 13.1046 8.89543 14 10 14Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
